<div class="formRow">
  <mat-form-field
    appearance="fill"
    class="w-100 formField"
    [class.hide]="isManualEntry"
  >
    <mat-label>{{ placeholder ? placeholder : "Address" }}</mat-label>
    <input
      matInput
      class="address"
      [formControl]="searchControl"
      #search
      autocomplete="off"
      (click)="search.focus()"
      (blur)="searchControl.markAsTouched()"
    />
    <mat-error *ngIf="searchControl.touched && searchControl.errors?.['addressRequired']">
      Address is required
    </mat-error>
  </mat-form-field>
</div>
<mat-hint [class.hide]="isManualEntry"
  >Can't find your address??
  <button
    mat-button
    id="manualEntryButton"
    (click)="setManualEntryMode()"
    aria-label="Click here to enter address manually"
    class="manualEntryButton"
    type="button"
  >
    Click here
  </button>
  to enter it manually.
</mat-hint>

<div [class.hide]="!isManualEntry">
  <form [formGroup]="formGroup">
    <div class="formRow">
      <mat-form-field appearance="fill" class="w-100 formField">
        <mat-label>{{ placeholder ? placeholder : "Address" }}</mat-label>
        <input matInput appNoSpecialChar="address" formControlName="streetAddress" />
        <mat-error
          *ngIf="
            formGroup.controls.streetAddress?.errors?.['required'] &&
            formGroup.controls.streetAddress.touched
          "
        >
          Address is required
        </mat-error>
        <mat-error
          *ngIf="formGroup.controls.streetAddress?.errors?.['maxlength'] &&
                       formGroup.controls.streetAddress?.touched"
        >
          Address must be less than {{formGroup.controls.streetAddress.errors?.['maxlength']['requiredLength']}} characters
        </mat-error>
        <mat-error
          *ngIf="formGroup.controls.streetAddress?.errors?.['minlength'] &&
                       formGroup.controls.streetAddress?.touched"
        >
          Address must be at least {{formGroup.controls.streetAddress.errors?.['minlength'].requiredLength}} characters
        </mat-error>
      </mat-form-field>
    </div>

    <div class="formRow">
      <mat-form-field appearance="fill" class="formField">
        <mat-label>Suburb</mat-label>
        <input matInput maxlength="32" formControlName="suburb" />
        <mat-error
          *ngIf="
            formGroup.controls.suburb?.errors?.['required'] && formGroup.controls.suburb.touched
          "
        >
          Suburb is required
        </mat-error>
        <mat-error
          *ngIf="formGroup.controls.suburb?.errors?.['maxlength'] &&
                       formGroup.controls.suburb?.touched"
        >
          Suburb must be less than {{formGroup.controls.suburb.errors?.['maxlength'].requiredLength}} characters
        </mat-error>
        <mat-error
          *ngIf="formGroup.controls.suburb?.errors?.['minlength'] &&
                       formGroup.controls.suburb?.touched"
        >
          Suburb must be at least {{formGroup.controls.suburb.errors?.['minlength'].requiredLength}} characters
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="formField">
        <mat-label>State</mat-label>
        <mat-select formControlName="state">
          <mat-option *ngFor="let state of states" [value]="state.value">{{
            state.value
          }}</mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            formGroup.controls.state?.errors?.['required'] && formGroup.controls.state.touched
          "
        >
          State is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="formField">
        <mat-label>Postcode</mat-label>
        <input appNumericOnly matInput maxlength="4" formControlName="postcode" />
        <mat-error
          *ngIf="
            formGroup.controls.postcode.errors?.['required'] &&
            formGroup.controls.postcode.touched
          "
        >
          Postcode is required
        </mat-error>
        <mat-error
          *ngIf="
            formGroup.controls.postcode.errors?.['pattern'] &&
            formGroup.controls.postcode.touched
          "
        >
          Please enter a valid postcode
        </mat-error>
      </mat-form-field>
    </div>
  </form>
  <mat-hint *ngIf="!readonly">
    <button
      mat-button
      id="searchButton"
      (click)="setSearchMode()"
      color="primary"
      aria-label="Click here to search for address"
      class="manualEntryButton"
      type="button"
    >
      Click here
    </button>
    to search for address
  </mat-hint>
</div>
